<template>
  <div class="border-t">
    <draggable v-model="addonList">
      <div v-for="addon in addons" :key="addon.id" class="flex items-center px-4 py-2 border-0 border-b cursor-pointer hover:bg-gray-50">
        <div class="pr-4 text-xs text-gray-400">
          <fa :icon="['fas', 'grip-vertical']" />
        </div>
        <div class="flex items-center space-x-4">
          <div>
            <div class="flex items-center font-semibold">
              {{ addon.name }}
            </div>
            <div class="text-gray-500">
              <currency :value="addon.price" :currency-code="account.currency" :subunits-value="true" />
            </div>
          </div>
        </div>
        <div class="ml-auto text-right">
          <div v-if="addon.status === 'active'">
            <badge class="text-green-800 bg-green-100">Active</badge>
          </div>
          <div v-else-if="addon.status === 'draft'">
            <badge class="text-cyan-800 bg-cyan-100">Draft</badge>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'AddonSort',

  components: {
    draggable
  },

  props: {
    addons: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters(['account']),

    addonList: {
      get () {
        return this.products
      },

      set (value) {
        this.$emit('update:addons', value)
      }
    }
  }
}
</script>
